<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="col-md-2 pl-0">
              <h4 class="">Data Table</h4>
              <div v-if="exportLoading">
                Loading. . .
              </div>
              <div v-else>
                <b-button size="sm" variant="primary" v-b-modal.modal-donasi @click="exportAccount">Export</b-button>
              </div>
              <div v-if="exportPaidLoading">
                Loading. . .
              </div>
              <div v-else>
                <b-dropdown size="sm" variant="primary" id="dropdown-download" class="m-md-1" no-caret>
                  <template #button-content>
                    <div v-if="exportPaidLoading">
                      <b-spinner small></b-spinner>
                    </div>
                    <div v-else>
                      Export Paid Account <span><i class="bx bxs-down-arrow"></i></span>
                    </div>
                  </template>
                  <b-dropdown-item-button :disabled="exportPaidLoading" @click="exportPaidAccount('fun_fall')">Fun Fall</b-dropdown-item-button>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item-button :disabled="exportPaidLoading" @click="exportPaidAccount('summer_camp')">Summer Camp</b-dropdown-item-button>
                </b-dropdown>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model.lazy="searchText"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div v-show="isFetched">
              <div class="mb-0">
                <vue-good-table
                    mode="remote"
                    :pagination-options="{
                      enabled: false,
                      mode: 'pages',
                      perPage: perPage,
                      position: 'bottom',
                      perPageDropdown: [5, 10],
                      dropdownAllowAll: false,
                      nextLabel: 'next',
                      prevLabel: 'prev',
                      rowsPerPageLabel: 'Rows per page',
                      ofLabel: 'of',
                      pageLabel: 'page', // for 'pages' mode
                      allLabel: 'All',
                    }"
                    :totalRows="totalRows"
                    :rows="accountData"
                    :columns="columns"
                    :sort-options="{
                      enabled: true,
                      initialSortBy: {field: 'id', type: 'desc'}
                    }"
                    @on-sort-change="onSortChange"
                    :row-style-class="rowStyleClassFn"
                >
                  <template slot="table-row" slot-scope="props">
                    <div v-if="props.column.field == 'btn'">
                      <div class="p-1">
                        <b-button pill variant="primary" size="sm" v-b-modal.modal-details @click="setModalData(props.row)">View Details</b-button>
                      </div>
                      <div class="p-1">
                        <b-button v-if="!props.row.certificate" pill size="sm" v-b-modal.modal-certificate @click="setModalCertificateData(props.row)">Create Certificate</b-button>
                        <b-button v-else pill size="sm" v-b-modal.modal-certificate @click="setModalCertificateData(props.row, 'edit')">Edit Certificate</b-button>
                      </div>
                    </div>
                    <div v-else-if="props.column.field == 'paid'">
                      <div v-if="Object.keys(props.row.transaction).length > 0">
                        {{ props.row.transaction.transaction_status ? (props.row.transaction.transaction_status === 'paid' ? "Paid" : "Not Paid") : "Not Paid" }}
                      </div>
                      <div v-else>
                        Not Paid
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>

              <b-modal id="modal-details" size="lg" title="Detail Account" button-size="sm">
                <div>
                  <p style="color: #000; width: 50%;float: left">
                    <span>Parent Full Name: </span> {{ activeAccount.parent_full_name }}<br>
                    <span>Phone Country Code: </span> {{ activeAccount.phone_country_code }}<br>
                    <span>Phone Number: </span> {{ activeAccount.phone_number }}<br>
                    <span>Parent Email: </span><a :href="'mailto:'+activeAccount.parent_email">{{ activeAccount.parent_email }}</a><br>
                    <span>Program Type: </span>{{ activeAccount.program_type }}<br>
                    <span>Program Length: </span>{{ activeAccount.program_length }}<br>
                    <span>Schedule Time: </span>{{ activeAccount.schedule_time }}<br>
                  </p>
                  <p style="width: 50%;float: left">
                    <span>Child Full Name: </span> {{ activeAccount.child_full_name }}<br>
                    <span>Child Age: </span> {{ activeAccount.child_age }}<br>
                    <span>Child Gender: </span>{{ activeAccount.child_gender_name }}<br>
                    <span>Child Email: </span> <a :href="'mailto:'+activeAccount.child_email">{{ activeAccount.child_email }}</a><br>
                  </p>
                </div>
                <template #modal-footer="{ cancel }">
                  <div class="w-100">
                    <b-button size="sm" @click="cancel" class="float-right">
                      Close
                    </b-button>
                  </div>
                </template>
              </b-modal>
              <b-modal id="modal-certificate" size="lg" title="Certificate" button-size="sm">
                <label>Certificate Code:</label>
                <b-form-input type="text" v-model="certificate.certificate_code" placeholder="Input Certificate Code"></b-form-input>
                <label>Completed Date:</label>
                <b-form-datepicker v-model="certificate.completed_date" class="mb-2" placeholder="Input Completed Date" locale="id"></b-form-datepicker>
                <label>Upload Certificate:</label>
                <b-form-file
                    v-model="certificateFile"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                ></b-form-file>
                <div v-if="mode === 'edit'">
                  Current Certificate:<br>
                  URL: <a :href="certificate.certificate_file_url" target="_blank">{{ certificate.certificate_file_url }}</a><br>
                  Short URL: <a :href="'http://'+certificate.certificate_short_url" target="_blank">{{ certificate.certificate_short_url }}</a><br>
                </div>
                <template #modal-footer="{ cancel, ok }">
                  <b-button size="sm" @click="cancel">
                    Close
                  </b-button>
                  <b-button v-if="mode === 'create'" variant="primary" :disabled="loadingUpdate" size="sm" @click="createCertificate">
                    <div v-if="loadingUpdate">
                      <b-spinner label="Loading..."></b-spinner>
                    </div>
                    <div v-else>
                      Submit
                    </div>
                  </b-button>
                  <b-button v-else variant="primary" :disabled="loadingUpdate" size="sm" @click="updateCertificate">
                    <div v-if="loadingUpdate">
                      <b-spinner label="Loading..."></b-spinner>
                    </div>
                    <div v-else>
                      Submit
                    </div>
                  </b-button>
                </template>
              </b-modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import axios from 'axios';
import debounce from "debounce";

export default {
  name: "account",
  page: {
    title: "Account",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader},
  created() {
    this.fetchAccountData()
  },
  data() {
    return {
      title: "Account",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Account",
          active: true
        }
      ],
      totalRows: 1,
      searchText: '',
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      isFetched: false,
      getArguments: {
        limit: 11,
        page: 1,
        sort: '-id',
        search: '',
      },
      accountData: [],
      columns: [
        { field: "id", label: "ID" },
        { field: "parent_full_name", label: "Parent Full Name"},
        { field: "child_gender_name", label: "Child Gender", sortable: false},
        { field: "child_full_name", label: "Child Full Name" },
        { field: "child_age", label: "Child Age" },
        { field: "phone_country_code", label: "Phone Country Code"  },
        { field: "phone_number", label: "Phone Number"  },
        { field: "parent_email", label: "Parent Email"  },
        { field: "child_email", label: "Child Email"  },
        { field: "program_type", label: "Program Type"   },
        { field: "program_length", label: "Program Length"   },
        { field: "schedule_time", label: "Schedule Time"   },
        { field: "paid", label: "Paid Status"   },
        { field: "btn", label: "Action", sortable: false  },
      ],
      activeAccount: {},
      optionsStatus: [
        { value: 'fully_paid', text: 'Mohon Pilih Status' },
        { value: 'processed', text: 'Pesanan Diproses' },
        { value: 'delivered', text: 'Pesanan Dikirim' },
        { value: 'completed', text: 'Pesanan Selesai'}
      ],
      deliveryPayload: {
        delivery_date: '',
        license_plate_number: '',
        driver_name: '',
        driver_phone: '',
      },
      logHistory: [],
      deliverySetting: {},
      loadingUpdate: false,
      ppn: 0.1,
      totalOrder: 0,
      exportLoading: false,
      downloadLoading: false,
      sendDocLoading: false,
      otherExpense: 0,
      temporaryStatus: '',
      certificate: {
        certificate_code: '',
        completed_date: ''
      },
      certificateFile: null,
      mode: 'create',
      exportPaidLoading: false
    }
  },
  computed: {

  },
  methods: {
    rowStyleClassFn() {
      return 'default'
    },
    setModalOrder(rowData) {
      this.otherExpense = 0
      this.activeAccount = rowData
      axios.get("/api/setting/delivery")
          .then((resp) => {
            const {data} = resp.data
            this.deliverySetting = data
            this.otherExpense = (rowData.qty * data.genose) + ((rowData.kantong_nafas/200) * data.kantong_nafas) + ((rowData.hme_filter/100) * data.hme_filter)
          })
    },
    setModalData(rowData) {
      this.activeAccount = rowData
    },
    setModalCertificateData(rowData, mode = 'create') {
      this.activeAccount = rowData
      if (mode !== 'create') {
        this.certificate = rowData.certificate
      } else {
        this.certificate = {}
      }
      this.mode = mode
      this.certificateFile = null
    },
    fetchAccountData() {
      let params = queryString.stringify({
        ...{
          search: null,
          sort: '-id',
        }
        , ...this.getArguments}
      )
      this.httpCallAccountData(params)
    },
    httpCallAccountData(params) {
      axios.get("/api/account?"+params)
          .then(resp => {
            const { data, pagination } = resp.data
            this.totalRows = pagination.total
            this.accountData = data
            this.isFetched = true
          });
    },
    exportAccount() {
      this.exportLoading = true
      axios.get("/api/account/export")
          .then(resp => {
            const { data } = resp.data
            var temp = 'data:application/vnd.ms-excel;base64,'
                +encodeURIComponent(data);
            var download = document.createElement('a');
            download.href = temp;
            download.download = 'account-export.xlsx';
            document.body.appendChild(download);
            download.click();
            document.body.removeChild(download);
            this.exportLoading = false
          });
    },
    exportPaidAccount(type) {
      this.exportPaidLoading = true
      let name = 'account-paid-export.xlsx';
      if (type === 'fun_fall') {
        name = 'account-paid-export-fun-fall.xlsx'
      }
      axios.get("/api/account/paid/export/"+type)
          .then(resp => {
            const { data } = resp.data
            var temp = 'data:application/vnd.ms-excel;base64,'
                +encodeURIComponent(data);
            var download = document.createElement('a');
            download.href = temp;
            download.download = name;
            document.body.appendChild(download);
            download.click();
            document.body.removeChild(download);
            this.exportPaidLoading = false
          });
    },
    onSortChange(params) {
      let sortBy = params[0].field
      if (params[0].type === 'desc') {
        sortBy = "-"+sortBy
      }
      this.getArguments.sort = sortBy
      let args = queryString.stringify(this.getArguments)
      this.httpCallAccountData(args)
    },
    createCertificate() {
      const validate = this.validateCertificate(false)
      if (validate.length > 0) {
        this.raiseValidationError(validate)
        return
      }

      this.loadingUpdate = true
      if (this.certificateFile != null) {
        // upload image first
        const data = new FormData()
        data.append('image', this.certificateFile, this.certificateFile.fileName);
        axios.post("/api/files/upload", data, {
          headers: {
            'accept': 'application/json',
            'Accept-Language': 'en-US,en;q=0.8',
            'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
          }
        }).then((resp) => {
          const {data} = resp.data
          this.certificate.certificate_file_url = data.url
          this.certificate.account_id = this.activeAccount.id
          axios.post("/api/certificate", this.certificate)
              .then(resp => {
                this.loadingUpdate = false
                Swal.fire('Success')
                this.$bvModal.hide('modal-certificate')
                this.fetchAccountData()
              }).catch(() => {
            this.loadingUpdate = false
            Swal.fire("Failed to process", "", "error")
          })
        }).catch(() => {
          this.loadingUpdate = false
          Swal.fire("Failed to process", "", "error")
        })
      } else {
        this.certificate.certificate_file_url = ''
        this.certificate.account_id = this.activeAccount.id
        axios.post("/api/certificate", this.certificate)
            .then(resp => {
              this.loadingUpdate = false
              Swal.fire('Success')
              this.$bvModal.hide('modal-certificate')
              this.fetchAccountData()
            }).catch(() => {
              this.loadingUpdate = false
              Swal.fire("Failed to process", "", "error")
            })
      }
    },
    updateCertificate() {
      const validate = this.validateCertificate(false)
      if (validate.length > 0) {
        this.raiseValidationError(validate)
        return
      }

      this.loadingUpdate = true
      if (this.certificateFile != null) {
        // upload image first
        const data = new FormData()
        data.append('image', this.certificateFile, this.certificateFile.fileName);
        axios.post("/api/files/upload", data, {
          headers: {
            'accept': 'application/json',
            'Accept-Language': 'en-US,en;q=0.8',
            'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
          }
        }).then((resp) => {
          const {data} = resp.data
          this.certificate.certificate_file_url = data.url
          this.certificate.account_id = this.activeAccount.id
          axios.put("/api/certificate/"+this.certificate.id, this.certificate)
              .then(resp => {
                this.loadingUpdate = false
                Swal.fire('Success')
                this.$bvModal.hide('modal-certificate')
                this.fetchAccountData()
              }).catch(() => {
                this.loadingUpdate = false
                Swal.fire("Failed to process", "", "error")
              })
        }).catch(() => {
          this.loadingUpdate = false
          Swal.fire("Failed to process", "", "error")
        })
      } else {
          this.certificate.account_id = this.activeAccount.id
          axios.put("/api/certificate/"+this.certificate.id, this.certificate)
              .then(resp => {
                this.loadingUpdate = false
                Swal.fire('Success')
                this.$bvModal.hide('modal-certificate')
                this.fetchAccountData()
              }).catch(() => {
                this.loadingUpdate = false
                Swal.fire("Failed to process", "", "error")
              })
      }
    },
    validateCertificate(include_certificate_file = true) {
      const payload = this.certificate
      let result = []
      if (payload.certificate_code === '') {
        result.push('code')
      }
      if (payload.completed_date === '') {
        result.push('completed_date')
      }
      if (this.certificateFile === null && include_certificate_file){
        result.push('certificate file')
      }

      return result
    },
    raiseValidationError(field) {
      const tagLi = field.map(x => '<li>Field '+ x.toUpperCase() +' belum diisi</li>').join('')
      Swal.fire({
        title: '',
        icon: 'error',
        html:
            `
            <b>Mohon isi data</b>
            <ul style="list-style-type:disc; text-align:left">
                ${tagLi}
            </ul>`,
        showCloseButton: false,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonText:
            'OK',
      })
    },
  },
  filters: {
    formatCurrency(number) {
      return number.toLocaleString() + ',-'
    }
  },
  watch: {
    searchText: {
      handler: debounce(function(value){
        this.currentPage = 1
        let params = queryString.stringify({
          limit: this.perPage,
          page: this.currentPage,
          search: value,
          sort: '-id',
        })
        this.httpCallAccountData(params)
      }, 500)
    },
    perPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1
        let params = queryString.stringify({
          limit: newValue,
          page: this.currentPage,
          search: this.searchText,
          sort: '-id',
        })
        this.httpCallAccountData(params)
      }
    },
    currentPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        let params = queryString.stringify({
          limit: this.perPage,
          page: newValue,
          search: this.searchText,
          sort: '-id',
        })
        this.httpCallAccountData(params)
      }
    },
  },
}
</script>

<style scoped>

</style>